import { Person } from '@/models/person';
import { PersonService } from '@/services/person.service';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';

export const personByInvitationResolver: ResolveFn<Person | null> = (route) => {
  const personService = inject(PersonService);

  return personService.retrieveByToken(route.queryParams['token']).pipe(
    catchError((error) => {
      console.error('Error retrieving person by invitation token:', error);
      return of(null);
    }),
  );
};
